import Home from "@/merchantWeb/Layout/index.vue";
export default [{
    path: '/',
    name: "Home",
    component: Home,
    children: [
        // 首页展示内容
        {
            path: "/index",
            name: "index",
            component: () => import("@/merchantWeb/MerchantIndex/index.vue"),
            meta: {
                webname: "merchant"
            }
        },
        // 表单
        {
            path: "/shops",
            name: "shops",
            component: () => import("@/merchantWeb/SubmitForm/index.vue"),
            meta: {
                webname: "merchant"
            }
        },
    ]
}]